import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AppSlider } from "../../../../../../shared/components/AppSlider";
import { AppUnderlinedTitle } from "../../../../../../shared/components/AppUnderlinedTitle";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { selectAssistantValue } from "../../../../redux/selectors";
import { TValueForService } from "../../../../../../services/api/instances/storageApi/types/service_types";
import { useAssistantField } from "../../../../hooks/use-assistant-field";
import { getUpdatedValue } from "../../../../helpers/getUpdatedValue";
import styles from "./styles.module.css";

interface Props {
  saveAssistant: (
    value: TValueForService<"assistants">,
    withDebounce: boolean,
  ) => void;
}

export const TemperatureSlider = ({ saveAssistant }: Props) => {
  const temperature = useAssistantField("temperature");
  const assistantValue = useAppSelector(selectAssistantValue);
  const { t } = useTranslation();

  const onTemperatureChange = useCallback(
    (_: any, value: number | number[]) => {
      if (!assistantValue?.assistant_object) return;
      const nextValue = (value as number) / 100;
      const updatedValue = getUpdatedValue(assistantValue, {
        temperature: nextValue,
      });
      saveAssistant(updatedValue, true);
    },
    [assistantValue],
  );

  const calculateValue = (value: number) => {
    return value / 100;
  };

  return (
    <div className={styles["slider-container"]}>
      <AppUnderlinedTitle
        className={styles["temperature-title"]}
        leftContent={t("assistants.temperature")}
      />
      <p className={styles["temperature-label"]}>{temperature?.toFixed(2)}</p>
      <AppSlider
        value={(temperature ?? 0) * 100}
        min={0}
        max={100}
        scale={calculateValue}
        onChange={onTemperatureChange}
      />
    </div>
  );
};
